import { creative as creativeConstants } from 'content-creation-common/constants';

export const {
  VALID_FILTERS,
  DEFAULT_KEYFRAME_NUMBER,
  DEFAULT_KEYFRAME_TRANSFORM,
} = creativeConstants;

export const REDUX_NAMESPACE = 'CREATIVES';

export const CREATIVE_ORIGINS = {
  AD_MANAGER_EMBED: 'AD_MANAGER_EMBED',
  DIRECT: 'DIRECT',
  DISCOVER: 'DISCOVER',
  PHOTO_ADS: 'PHOTO_ADS',
  STORY_STUDIO: 'STORY_STUDIO',
  STORY_STUDIO_AUTO_SNAP: 'STORY_STUDIO_AUTO_SNAP',
};

export const VALID_CREATIVE_ORIGINS = new Set(Object.keys(CREATIVE_ORIGINS));

export const DOWNLOAD_FRAME_WIDTH = 540;
export const DOWNLOAD_FRAME_HEIGHT = 960;

export const MIN_FRAMES_PER_CREATIVE_PARTIALS = 100;

export const CREATIVE_STATUS_FINALIZED = 'FINALIZED';

export const MAX_CREATIVE_DIMENSION_LENGTH_IN_PX = 1920;
export const MIN_CREATIVE_DIMENSION_LENGTH_IN_PX = 50;

// DEFAULT CREATIVE'S PROPERTIES
export const DEFAULT_MASK_NAME = 'root';

export const DEFAULT_CREATIVE_HEIGHT_PX = 1920;
export const DEFAULT_CREATIVE_WIDTH_PX = 1080;

export const DEFAULT_STAGE_COLOR = '#FFFFFF';
export const DEFAULT_SHAPE_COLOR = '#1b2631';

export const DEFAULT_CREATIVE_NAME = 'New Project';

export const DEFAULT_CREATIVES_LIMIT = 50;

export const MAX_CREATIVE_LIMIT = 300;
